<template>
  <div
      class="border gmb-color-palette-picto"
      :style="{ backgroundColor: color }"
  />
</template>

<script>
export default {
  name: "GmbColorPalettePicto",

  components: {},

  props: {
    color: String,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss">
@import "@/sass/settings/dimensions";

/* =========================================================================
 * COLOR PALETTE PICTO
 * ========================================================================= */

.gmb-color-palette-picto {
  width: 12px;
  height: 12px;
  border-radius: $gmb-border-radius-1;
}
</style>
